export default __webpack_public_path__ + "static/media/Gallery-14.0a9d78ed.jpeg";